export default function VisibilityBadge({ visibility }) {
  const isPublic = visibility === "public";

  const styles = isPublic
    ? "bg-blue-100 text-blue-700"
    : "bg-purple-100 text-purple-700";

  const label = isPublic ? "Public" : "Private";

  return (
    <span className={`px-2 py-0.5 text-xs rounded-full ${styles}`}>
      {label}
    </span>
  );
}
